// React
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
// Framework
import { Typography, alpha, makeStyles, useTheme } from "@material-ui/core";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles((theme) => ({
  root: {
    width: "fit-content",
    backgroundColor: theme.palette.common.white,
  },
  content: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.radius.small,
    padding: theme.spacing(0.5, 1),
    border: `1px solid`,
  },
  text: {
    userSelect: "none",
    fontWeight: 500,
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const Tag = forwardRef(
  ({ label, color, textColor, transparency = 0.2 }, ref) => {
    // Styles
    const classes = useStyles();
    const theme = useTheme();
    // Render
    return (
      <div className={classes.root} ref={ref}>
        <div
          className={classes.content}
          style={{
            color: textColor ?? alpha(theme.palette.common.black, 0.8),
            backgroundColor: color
              ? alpha(color, transparency)
              : theme.palette.background.prominent.main,
            borderColor: color
              ? alpha(color, transparency + 0.25)
              : theme.palette.border.prominent.color,
          }}
        >
          <Typography
            noWrap
            color="inherit"
            variant="caption"
            component="div"
            display="block"
            className={classes.text}
          >
            {label}
          </Typography>
        </div>
      </div>
    );
  }
);

Tag.propTypes = {
  /**
   * Tag's title
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /**
   * Color of the tag
   */
  color: PropTypes.string,
  /**
   * Color of the text
   */
  textColor: PropTypes.string,
};

export default Tag;
